import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

export const productReportFilters: UniversalFilterConfig[] = [
  {
    name: "productId",
    label: "Producto",
    type: "searchSelect",
    iconKey: "product",
  },
  {
    name: "categoryId",
    label: "Categoría",
    type: "searchSelect",
    iconKey: "category",
  },
  {
    name: "unitId",
    label: "Unidad de Medida",
    type: "searchSelect",
    iconKey: "unit",
  },
  {
    name: "priceMin",
    label: "Precio Mínimo",
    type: "number",
    iconKey: "dollar",
  },
  {
    name: "priceMax",
    label: "Precio Máximo",
    type: "number",
    iconKey: "dollar",
  },
  {
    name: "costMin",
    label: "Costo Mínimo",
    type: "number",
    iconKey: "dollar",
  },
  {
    name: "costMax",
    label: "Costo Máximo",
    type: "number",
    iconKey: "dollar",
  },
  {
    name: "stockMin",
    label: "Stock Mínimo",
    type: "number",
    iconKey: "product",
  },
  {
    name: "stockMax",
    label: "Stock Máximo",
    type: "number",
    iconKey: "product",
  },
];
